/*
  Promotions: browser-side timing guard, countdowns and terms links. Loaded on every page by
  snippets/promotion-timing-script.liquid. Liquid already renders promotions only inside their dates;
  this catches cached pages, so an ended (or not yet started) promotion hides on time.

  - Any [data-promo-start][data-promo-end] element (epoch seconds, 0 = none) outside its window gets
    the hidden attribute. Limits (homepage cap, one top bar, badge limits) are CSS rules that skip
    hidden elements, so the next promotion in priority order takes the freed place.
  - [data-promo-countdown="<end epoch>"] shows days, hours and minutes left.
  - Links to #promo-terms-{id} open that terms panel.
  - Inside the theme editor, TAT.promoNow (the preview date) replaces the visitor's clock.
*/
const TAT = (window.TAT = window.TAT || {});
const nowSeconds = () => (TAT.promoNow ? Number(TAT.promoNow) : Date.now() / 1000);

function applyTiming(root = document) {
  const now = nowSeconds();
  root.querySelectorAll('[data-promo-start][data-promo-end]').forEach((el) => {
    const start = Number(el.dataset.promoStart) || 0;
    const end = Number(el.dataset.promoEnd) || 0;
    const live = now >= start && (!end || now <= end);
    if (!live) {
      el.hidden = true;
      el.dataset.promoExpired = '';
    } else if (el.hasAttribute('data-promo-expired')) {
      el.hidden = false;
      delete el.dataset.promoExpired;
    }
  });
}

function updateCountdowns() {
  const now = nowSeconds();
  document.querySelectorAll('[data-promo-countdown]').forEach((el) => {
    const left = Number(el.dataset.promoCountdown) - now;
    if (!(left > 0)) {
      el.hidden = true;
      return;
    }
    const set = (sel, value) => {
      const part = el.querySelector(sel);
      // Only write on change, so the MutationObserver below doesn't loop.
      if (part && part.textContent !== String(value)) part.textContent = String(value);
    };
    set('[data-days]', Math.floor(left / 86400));
    set('[data-hours]', Math.floor((left % 86400) / 3600));
    set('[data-mins]', Math.floor((left % 3600) / 60));
    el.hidden = false;
  });
}

function openTerms(hash) {
  if (!hash || !hash.startsWith('#promo-terms-')) return;
  const panel = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (panel && panel.tagName === 'DETAILS') panel.open = true;
}

// Re-check every 30 seconds once promotions are on the page (cheap: a few attribute reads).
// Started from tick() so promotions that arrive later (filters, cart drawer, editor) also get it.
let interval = 0;

function tick() {
  applyTiming();
  updateCountdowns();
  if (!interval && document.querySelector('[data-promo-start], [data-promo-countdown]')) {
    interval = setInterval(tick, 30000);
  }
}

tick();
openTerms(window.location.hash);

// Content added later (filters, cart drawer, recommendations) is checked once it lands.
let queued = false;
new MutationObserver(() => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    tick();
  });
}).observe(document.body, { childList: true, subtree: true });

window.addEventListener('hashchange', () => openTerms(window.location.hash));
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href^="#promo-terms-"]');
  if (link) openTerms(link.getAttribute('href'));
});
